import ReleaseNotes from "./ReleaseNotes";

export default ReleaseNotes;
